import React, { useEffect, useState } from "react";
import { historyRecharge } from "../../components/Service/CreditService";
import { Table, Pagination, Form } from "react-bootstrap";
import useLanguage from "../../Hooks/useLanguage";
import { useTranslation } from 'react-i18next';
import LoadingSpinner from "../../css/Loading";
function HistoryRecharge() {
    const [invoice, setInvoice] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const data = await historyRecharge();
            const sortedData = data?.transaction?.sort((a, b) => b.id - a.id) || [];
            setInvoice(sortedData);
            setLoading(false);
        };
        fetchData();
    }, []);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = invoice.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(invoice.length / itemsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
    useLanguage();

    const { t } = useTranslation();
    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };
    if (loading) {
        return (
            <LoadingSpinner></LoadingSpinner>
        );
    }
    return (
        <div
            className="container mt-4"
        // style={{
        //     display: 'flex',
        //     flexDirection: 'column',
        //     height: '100vh', 
        // }}
        >
            <h3 className="text-center mb-4" style={{ color: "#007bff", textTransform: "uppercase" }}>{t("Transaction history")}</h3>

            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    {`${invoice.length
                        } ${t("Records Found")}, ${t("Showing")} ${indexOfFirstItem + 1} ${t("to")} ${Math.min(
                            indexOfLastItem,
                            invoice.length
                        )}`}
                </div>

                <div className="d-flex align-items-center">
                    <Form.Label className="mr-2">{t("Showing")}:</Form.Label>
                    <Form.Control
                        as="select"
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                        style={{ width: "auto" }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </Form.Control>
                </div>
            </div>

            <div
                className="table-responsive"
            // style={{
            //     flex: 1,
            //     overflowY: 'auto', 
            //     marginBottom: '70px', 
            // }}
            >
                <Table bordered hover className="table-custom">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>STT</th>
                            <th>{t("Payment gateway")}</th>
                            <th>{t("Transaction type")}</th>
                            <th>{t("Payment method")}</th>
                            <th>{t("Status")}</th>
                            <th>{t("Total Amount")}</th>
                            <th>{t("Time")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.map((row, index) => (
                            <tr key={row.id} className="text-center">
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td>
                                    {row.gateway_id === 1 ? "NeoX" : row.gateway_id === 2 ? "PayPal" : row.gateway_id === 3 ? "Wallet" : "Bank Transfer"}
                                </td>
                                <td>{row.type === 2 ? t("Add funds") : row.type === 1 ? t("Invoice") : "Invoice Change Package"}</td>
                                <td>{t(row.payment_method)}</td>

                                <td>
                                    <span className={`badge ${row.status === 1 ? "badge-success" : "badge-danger"}`}>
                                        {row.status === 1 ? t("Success") : t("Failure")}
                                    </span>
                                </td>
                                <td>
                                    {(Number(row.amount)).toLocaleString('vi-VN', { style: 'currency', currency: 'VND' })}
                                </td>
                                <td>
                                    {new Date(row.created_at).toLocaleDateString('vi-VN', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })} -
                                    {new Date(row.created_at).toLocaleTimeString('vi-VN', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                    })}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <div
                className="d-flex justify-content-center mt-4"
            // style={{
            //     position: 'sticky',
            //     bottom: '0', 
            //     backgroundColor: 'white',
            //     zIndex: 1000,
            //     display: 'flex',
            //     justifyContent: 'center',
            //     padding: '10px 0',
            //     boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)', 
            // }}
            >
                <Pagination>
                    <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        {t("Previous")}
                    </Pagination.Prev>

                    {[...Array(totalPages)].map((_, i) => (
                        <Pagination.Item
                            key={i + 1}
                            active={i + 1 === currentPage}
                            onClick={() => handlePageChange(i + 1)}
                        >
                            {i + 1}
                        </Pagination.Item>
                    ))}

                    <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        {t("Next")}

                    </Pagination.Next>
                </Pagination>
            </div>
        </div>
    );
}

export default HistoryRecharge;
